export const getAlias = (data?: Partial<{ email: string; phone: string }>) => {
  const { email, phone } = { ...data }

  return email || phone
}
